/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Categories_EngineInputs */

const en_us2_technologies_categories_engine = /** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engine`)
};

const es_es2_technologies_categories_engine = /** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor`)
};

const ru_technologies_categories_engine = /** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игровой движок`)
};

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const id_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const ms_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const da_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const de_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const es_mx2_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const fil_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const fr_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const it_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const hu_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const nl_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const no_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const pl_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const pt_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const pt_br2_technologies_categories_engine = pt_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const ro_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const fi_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const sv_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const vi_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const tr_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const cs_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const bg_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const uk_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const ar_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const hi_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const th_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const ja_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const zh_cn2_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const zh_hant1_technologies_categories_engine = en_us2_technologies_categories_engine;

/** @type {(inputs: Technologies_Categories_EngineInputs) => LocalizedString} */
const ko_technologies_categories_engine = en_us2_technologies_categories_engine;

/**
* | output |
* | --- |
* | "Engine" |
*
* @param {Technologies_Categories_EngineInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_categories_engine = /** @type {((inputs?: Technologies_Categories_EngineInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Categories_EngineInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_categories_engine(inputs)
	if (locale === "ms") return ms_technologies_categories_engine(inputs)
	if (locale === "da") return da_technologies_categories_engine(inputs)
	if (locale === "de") return de_technologies_categories_engine(inputs)
	if (locale === "en-US") return en_us2_technologies_categories_engine(inputs)
	if (locale === "es-ES") return es_es2_technologies_categories_engine(inputs)
	if (locale === "es-MX") return es_mx2_technologies_categories_engine(inputs)
	if (locale === "fil") return fil_technologies_categories_engine(inputs)
	if (locale === "fr") return fr_technologies_categories_engine(inputs)
	if (locale === "it") return it_technologies_categories_engine(inputs)
	if (locale === "hu") return hu_technologies_categories_engine(inputs)
	if (locale === "nl") return nl_technologies_categories_engine(inputs)
	if (locale === "no") return no_technologies_categories_engine(inputs)
	if (locale === "pl") return pl_technologies_categories_engine(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_categories_engine(inputs)
	if (locale === "pt") return pt_technologies_categories_engine(inputs)
	if (locale === "ro") return ro_technologies_categories_engine(inputs)
	if (locale === "fi") return fi_technologies_categories_engine(inputs)
	if (locale === "sv") return sv_technologies_categories_engine(inputs)
	if (locale === "vi") return vi_technologies_categories_engine(inputs)
	if (locale === "tr") return tr_technologies_categories_engine(inputs)
	if (locale === "cs") return cs_technologies_categories_engine(inputs)
	if (locale === "bg") return bg_technologies_categories_engine(inputs)
	if (locale === "ru") return ru_technologies_categories_engine(inputs)
	if (locale === "uk") return uk_technologies_categories_engine(inputs)
	if (locale === "ar") return ar_technologies_categories_engine(inputs)
	if (locale === "hi") return hi_technologies_categories_engine(inputs)
	if (locale === "th") return th_technologies_categories_engine(inputs)
	if (locale === "ja") return ja_technologies_categories_engine(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_categories_engine(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_categories_engine(inputs)
	return ko_technologies_categories_engine(inputs)
});
export { technologies_categories_engine as "technologies.categories.engine" }